export default IconCubeUnfolded => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-cube-unfolded" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M2 15h10v5h5v-5h5v-5h-10v-5h-5v5h-5z" />
  <path d="M7 15v-5h5v5h5v-5" />
</svg>`;